module.exports = __webpack_public_path__ + "img/1122941708.e2342261.png";